import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-598e60d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["label", "disabled", "checked"]
const _hoisted_2 = { key: 1 }

import { computed, withDefaults, useAttrs } from 'vue';
import omit from '@/utils/omit';

// const { calcFieldSize } = useField()


const __default__ = {
  inheritAttrs: false,
};

interface InputProps {
  modelValue?: any;
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  labelStart?: boolean;
  labelEnd?: boolean;
  noMargin?: boolean;
  sizeLabel?: string
  colorLabel?: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AtomCheckBox',
  props: {
    modelValue: { default: '' },
    label: null,
    disabled: { type: Boolean },
    checked: { type: Boolean },
    labelStart: { type: Boolean, default: false },
    labelEnd: { type: Boolean, default: true },
    noMargin: { type: Boolean },
    sizeLabel: null,
    colorLabel: null
  },
  emits: ["update:modelValue", "click", "keydown", "focus", "update:hint"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string | number | null | boolean): void;
  (e: 'click', event: MouseEvent): void;
  (e: 'keydown', event: KeyboardEvent): void;
  (e: 'focus', event: PointerEvent): void;
  (e: 'update:hint', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: any, label?: string, disabled?: boolean, checked?: boolean, labelStart: boolean, labelEnd: boolean, noMargin?: boolean, sizeLabel?: string, colorLabel?: string };

_useCssVars(_ctx => ({
  "4a8be821": (__props.colorLabel)
}))




// const emit = defineEmits(['click', 'keydown', 'update:modelValue', 'focus', 'update:hint'])

const attrs = useAttrs();

const listeners = computed(() => ({
  input: emitValue,
  keydown: processValue,
  blur: (e: Event) => {
    if (typeof attrs.onBlur === 'function') attrs.onBlur(e);
  },
  focus: (e: PointerEvent) => emit('focus', e),
}));

const attributes = computed(() => omit(attrs, 'class'));

const processValue = (event: KeyboardEvent) => {
  if (!event.key) return;

  emit('keydown', event);
};

const emitValue = (event: InputEvent) => {
  const value = (event.target as HTMLInputElement).checked;
  emit('update:modelValue', value);
};
// const value = computed({
//   get: () => props.modelValue,
//   set: (value: any) => emit('update:modelValue', value),
// })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "label-check py-1",
    style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '' })
  }, [
    (props.label && props.labelStart)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(`ms-3 me-auto`),
          style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '' })
        }, _toDisplayString(props.label), 5))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({
      type: "checkbox",
      class: `${__props.noMargin ? '' : 'ms-8'} justify-end`
    }, _unref(attributes), {
      label: props.label,
      disabled: __props.disabled,
      checked: __props.checked
    }, _toHandlers(_unref(listeners), true)), null, 16, _hoisted_1),
    (props.label && props.labelEnd)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true)
  ], 4))
}
}

})